module.exports = __webpack_public_path__ + "static/media/3-item-d.0f8b3ea0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/men/3-item-d.jpg
// module id = 1165
// module chunks = 33